<template>
  <div class="col-xs-12">
    <button
      :disabled="loading || unableToSend"
      type="button"
      @click.prevent="showImage()"
      class="btn btn-fill btn-block"
    >
      Tirar Foto
    </button>

    <el-dialog
      title="Tirar fotos dos documentos"
      :visible.sync="showImageCapture"
      :modal-append-to-body="false"
      width="50%"
      :modal="true"
      v-if="canTakeAnotherPhoto"
    >
      <customer-image-capture @on-image-captured="handleSave($event)"></customer-image-capture>
    </el-dialog>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import swal from 'sweetalert2'
  import Couchdb from 'src/services/Couchdb'
  import CustomerImageCapture from 'src/pages/Customers/CustomerImageCapture.vue'
  import File from 'src/services/File'

  export default {
    name: 'BtnTakePhotos',

    components: {
      CustomerImageCapture
    },

    props: {
      ticket: {
        required: true,
        type: Object
      },

      event: {
        required: true,
        type: Object
      }
    },

    data () {
      return {
        isLoadingFile: false,
        loading: false,
        showImageCapture: false,
        canTakeAnotherPhoto: true
      }
    },

    computed: {
      unableToSend () {
        let blockByWinnerRanking = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking'
        return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking
      }
    },

    methods: {
      ...mapActions('tickets', ['setStateOne']),

      showImage () {
        this.showImageCapture = true
      },

      async handleSave (data) {
        if (this.unableToSend) {
          return this.notifyUnable()
        }

        this.loading = true
        this.isLoadingFile = true

        let file = File.base64ToBinary(data.image)

        let docId = await this.getIdDocument()

        await Couchdb.connection('docs').insertAttachment(docId, {
          mimeType: 'image/jpeg',
          attachmentName: 'image-' + this.generateNumber() + '.jpg',
          attachment: file
        })

        let date = new Date()

        let newTicket = Object.assign({}, this.ticket, {documentedAt: date})

        delete newTicket.event
        delete newTicket.stock
        delete newTicket.customer

        try {
          await Couchdb.connection('default')
            .updateWithView({
              ddoc: 'tickets-by-id',
              view: 'tickets-by-id',
              payload: newTicket,
              database: 'default'
            })

          this.setStateOne(newTicket)
          this.isLoadingFile = false
          this.showImageCapture = false
          this.notifySuccess()
          this.showImageCapture = false
          this.canTakeAnotherPhoto = false
          this.$nextTick(() => {
            this.canTakeAnotherPhoto = true
          })
        } catch (e) {
          console.log(e)
        }

        this.loading = false
      },

      async getIdDocument () {
        let referenceDoc = await Couchdb.connection('docs')
          .view('docs-by-reference-id', 'docs-by-reference-id', this.ticket._id)

        referenceDoc = referenceDoc.rows[0] && referenceDoc.rows[0].value ? referenceDoc.rows[0].value : undefined

        if (referenceDoc) {
          return referenceDoc._id
        }

        let doc = await Couchdb.connection('docs')
          .insert({
            'database': process.env.DB_NAME,
            'referenceId': this.ticket._id,
            'collection': 'docs'
          })
        return doc.id
      },

      generateNumber () {
        return Math.floor(Math.random() * 90000) + 10000
      },

      notifyUnable () {
        return swal({
          text: `Não é possível enviar documentação para este cliente.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      },

      notifySuccess () {
        this.$notify({
          message: 'Documentação salva com sucesso.',
          type: 'success'
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/BtnTakePhotos.vue